<div class="main-container">
    <res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
        [modalHelpIndex]="modalHelpIndex" [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()"
        (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
        [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
        [modalDraggable]=false>

        <div class="left-right-container">
            <div class="name-description-container">
                <res-name-description [name]="nameDescriptionComponent.name"
                    [description]="nameDescriptionComponent.description"
                    [validateNameRequest]="nameDescriptionComponent.validateNameRequest" [validateName]="true"
                    [automationId]="modalAutomationId">
                </res-name-description>
            </div>
            <div class="document-container">
                <div class="left-container" automationId="create-comparison-left-container">
                    <div class="document-set-A">
                        <span requiredAsterisk> Document Set A: </span>
                    </div>
                    <res-target-picker-tree [targetPickerTreeType]="targetPickerTreeType"
                        [automationId]="modalAutomationId + '-treeA'" [preselectNodePredicate]="preselectNodePredicateA"
                        [getSelectedSearchNodeCallback]="getSelectedSearchNodeCallbackA"></res-target-picker-tree>
                </div>
                <div class="middle-container">
                    <span><i class="fa fa-exchange color-purple-02"></i></span>
                </div>
                <div class="right-container" automationId="create-comparison-right-container">
                    <div class="document-set-B">
                        <span requiredAsterisk> Document Set B: </span>
                    </div>
                    <res-target-picker-tree [targetPickerTreeType]="targetPickerTreeType"
                        [automationId]="modalAutomationId + '-treeB'" [preselectNodePredicate]="preselectNodePredicateB"
                        [getSelectedSearchNodeCallback]="getSelectedSearchNodeCallbackB"></res-target-picker-tree>
                </div>
            </div>
        </div>
    </res-base-modal>
</div>